import React from "react";
import { type BackupConfig } from "../../../services/BackupService";

interface BackupScheduleInfoProps {
  config: BackupConfig | null;
}

export const BackupScheduleInfo: React.FC<BackupScheduleInfoProps> = ({
  config,
}) => {
  const formatTimestamp = (timestamp: string) => {
    return new Date(timestamp).toLocaleString();
  };

  return (
    <div className="mb-4">
      <h3 className="font-medium mb-2">Backup Schedule</h3>
      {config ? (
        <>
          <p className="text-sm text-gray-600">
            {config.frequency === "manual"
              ? "Manual backups only"
              : `Automatic backups: ${config.frequency}`}
          </p>
          {config.lastBackup && (
            <p className="text-sm text-gray-600">
              Last backup: {formatTimestamp(config.lastBackup)}
            </p>
          )}
        </>
      ) : (
        <p className="text-sm text-gray-500">Loading configuration...</p>
      )}
    </div>
  );
};
